import { Box, Card, CardContent, Typography } from "@mui/material";
import { AppColors } from "../../constants/AppColors";

type PageHeaderProps = {
  title: string;
  description?: string;
  action?: React.ReactNode;
  eyebrow?: string;
};

export const PageHeader = ({
  title,
  description,
  action,
  eyebrow,
}: PageHeaderProps) => {
  return (
    <Card
      elevation={0}
      sx={{
        mb: 3,
        borderRadius: 4,
        border: `1px solid ${AppColors.border}`,
        bgcolor: AppColors.card,
        boxShadow: AppColors.shadowCard,
      }}
    >
      <CardContent
        sx={{
          p: { xs: 2, sm: 2.5 },
          "&:last-child": {
            pb: { xs: 2, sm: 2.5 },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            {eyebrow ? (
              <Typography
                sx={{
                  color: AppColors.primary,
                  fontWeight: 950,
                  textTransform: "uppercase",
                  fontSize: 12,
                  letterSpacing: 0.8,
                  mb: 0.5,
                }}
              >
                {eyebrow}
              </Typography>
            ) : null}

            <Typography
              variant="h4"
              sx={{
                fontWeight: 950,
                lineHeight: 1.12,
                color: AppColors.textPrimary,
                wordBreak: "break-word",
              }}
            >
              {title}
            </Typography>

            {description ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mt: 0.65,
                  maxWidth: 860,
                  lineHeight: 1.45,
                  fontWeight: 650,
                }}
              >
                {description}
              </Typography>
            ) : null}
          </Box>

          {action ? (
            <Box
              sx={{
                flexShrink: 0,
                width: { xs: "100%", md: "auto" },
                display: "flex",
                justifyContent: { xs: "flex-start", md: "flex-end" },
              }}
            >
              {action}
            </Box>
          ) : null}
        </Box>
      </CardContent>
    </Card>
  );
};
